import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV, SITE } from "@/data/site";
import ThemeToggle from "./ThemeToggle";

function Logo() {
    return (
        <Link
            to="/"
            data-testid="logo-link"
            className="flex items-center gap-2 font-heading text-xl font-extrabold tracking-tight text-primary"
        >
            <span aria-hidden>💰</span>
            <span>{SITE.name}</span>
        </Link>
    );
}

export default function Header() {
    const [open, setOpen] = useState(false);
    return (
        <header className="sticky top-0 z-50 border-b border-border/60 bg-background/70 backdrop-blur-xl">
            <div className="container-gr flex h-16 items-center justify-between">
                <Logo />
                <nav className="hidden items-center gap-8 md:flex" aria-label="Główna nawigacja">
                    {NAV.map((n) => (
                        <Link
                            key={n.href}
                            to={n.href}
                            data-testid={`nav-${n.label.toLowerCase()}`}
                            className="text-sm font-medium text-muted-foreground transition-colors hover:text-foreground"
                        >
                            {n.label}
                        </Link>
                    ))}
                </nav>
                <div className="flex items-center gap-3">
                    <ThemeToggle />
                    <Link
                        to="/download"
                        data-testid="header-cta"
                        className="hidden rounded-full bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground transition-colors hover:brightness-110 active:scale-95 sm:inline-flex"
                    >
                        Pobierz aplikację
                    </Link>
                    <button
                        type="button"
                        data-testid="mobile-menu-toggle"
                        aria-label="Menu"
                        onClick={() => setOpen((v) => !v)}
                        className="grid h-10 w-10 place-items-center rounded-full border border-border md:hidden"
                    >
                        {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
                    </button>
                </div>
            </div>
            {open && (
                <nav className="container-gr flex flex-col gap-1 border-t border-border/60 py-4 md:hidden" aria-label="Nawigacja mobilna">
                    {NAV.map((n) => (
                        <Link
                            key={n.href}
                            to={n.href}
                            onClick={() => setOpen(false)}
                            data-testid={`mobile-nav-${n.label.toLowerCase()}`}
                            className="rounded-lg px-3 py-3 text-base font-medium text-foreground transition-colors hover:bg-secondary"
                        >
                            {n.label}
                        </Link>
                    ))}
                    <Link
                        to="/download"
                        onClick={() => setOpen(false)}
                        data-testid="mobile-header-cta"
                        className="mt-2 rounded-full bg-primary px-5 py-3 text-center text-base font-semibold text-primary-foreground"
                    >
                        Pobierz aplikację
                    </Link>
                </nav>
            )}
        </header>
    );
}
